import React from 'react'

export default function AnotacionesGrupoFamiliar() {
  return (
    <div>
      AnotacionesGrupoFamiliar
    </div>
  )
}
